<template>
  <div class="relative flex items-center justify-between px-2 py-2 shadow bg-slate-300">
    <button @click="$router.go(-1)" class="absolute leading-none text-left text-gray-600">
      <i class="text-2xl leading-none ion-md-arrow-back"></i>
    </button>

    <p class="flex-1 py-1 text-2xl text-center">
      <slot></slot>
    </p>

    <button class="absolute text-lg text-right text-gray-600 right-2" @click="$router.push({name: action.route})">
      {{ action.text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    action: { type: Object, required: false, default: {text: null, route: null} },
  },
}
</script>
